module.exports = "/static/js/9472cc3a0ee67976c0db6ccb30d24c23.png";